export function reorderForLeftToRightDisplay<T>(items: T[], columnCount: number = 2): T[] {
  const rowCount = Math.ceil(items.length / columnCount);
  const reordered: T[] = [];

  // Fill columns one by one
  for (let col = 0; col < columnCount; col++) {
    for (let row = 0; row < rowCount; row++) {
      const index = row * columnCount + col;
      if (index < items.length) {
        reordered.push(items[index] as T);
      }
    }
  }

  return reordered;
}
